interface DescriptionProps {
  description: string
  productCode?: string
}

export function Description({ description, productCode }: DescriptionProps) {
  return (
    <>
      {productCode && (
        <p className="desktop-caption-regular text-tertiary mb-3">
          REF: {productCode}
        </p>
      )}
      <div
        suppressHydrationWarning
        dangerouslySetInnerHTML={{ __html: description }}
        className="desktop-body-regular-text3 text-restructure-tertiary"
      />
    </>
  )
}
